export default function ProjetsHeader() {
  return (
    <header className="projects-header container">
      <span className="subheading">Projects</span>
      <h2 className="heading-secondary">My journey as a Frontend developer</h2>
    </header>
  );
}
